import type {DisplayObject} from "@gamzix/slot_core";

import {CONST} from '../../../src/const';

class GameReelsetComponent extends SlotGame.src.component.ReelsetComponent {
    public TIME_STOP_DELAY = 400;
    public MIN_SPIN_DURATION = 300;

    async onStartBonusGame() {
        await game.utils.delay(500);

        super.onStartBonusGame();
    }

    async onFinishBonusGame() {
        await game.utils.delay(500);

        super.onFinishBonusGame();
    }

    // height + 1 because bug OLHS-56
    createCellReelSetMasks(symbolHeight) {
        for (let i = 0; i < this.rows; i++) {
            const mask: DisplayObject = game.builder.create({
                "type": "FastRect",
                "name": `cell_reelset_mask.row_${i}`,
                "width": this.rowWidth,
                "height": symbolHeight + 1,
                "position": {"x": 0, "y": this.getRowPosition(i, symbolHeight)}
            })
            this.view.addChild(mask);
        }
    }

    checkShowWinShowWinLines() {
        const isOneLine = this.store.gameData.lines.length == 1 && this.store.gameData.positions.length === 0;
        if (this.store.gameData.lines.length >= this.options.config.linesToSkip || isOneLine) return false;

        return this.store.gameData.hasLineWins() &&
            !(
                this.store.gameData.freeSpinsGame.isPlaying() ||
                this.store.gameData.freeSpinsGame.hasSpins() ||
                this.store.gameData.bonusGame.isPlaying() ||
                this.store.gameData.bonusGame.hasSpins() ||
                this.store.autoplay.isActive
            );
    }

    getAnticipationReelsMap(): boolean[] {
        const {gameData} = this.store;
        const map = [false, false, false, false, false];

        if (this.store.gameData.bonusGame.isPlaying()) {
            return map;
        }

        this.anticipationConfig.triggers.forEach(({
                                                      triggerSymbolList,
                                                      maxCountScatterOnReel,
                                                      minCountScatterForStart,
                                                      countScattersForStart,
                                                      maxCountScattersForStart,
                                                      filter
                                                  }) => {
            let countScatters = 0;
            const pFilter = filter || gameData.reels.map(() => true);

            gameData.reels
                .forEach((reelData, index) => {
                    if(maxCountScattersForStart && maxCountScattersForStart <= countScatters) {
                        map[index] = false;
                        return;
                    }

                    const countOnReel = reelData.filter(symbolData => triggerSymbolList.includes(symbolData?.symbol.toString())).length;
                    const maxCountPossibleScatters = countScatters + (this.column - index) * maxCountScatterOnReel;

                    if (countScatters >= minCountScatterForStart && maxCountPossibleScatters >= countScattersForStart && Boolean(pFilter[index])) {
                        map[index] = true;
                    }

                    countScatters += countOnReel;
                });
        });

        return map;
    }

    async onIdleWaitSpin() {
        this.playAllIdleAnimation();

        if (this.store.gameData.mode != "bonus") {
            await this.waitClick();
        }
    }

    async showBonusSymbolsWin() {

        this.playAllLoseAnimation();

        let positions = [];

        this.store.gameData.reels.forEach((reel, x) => {
            reel.forEach((sym, y) => {
                if (sym?.symbol == CONST.SYMBOLS.COIN) {
                    positions.push([x, y]);
                }
            })
        })

        // for winFrame
        game.emit("ReelsetComponent.SHOW_BONUS_SYMBOLS_WIN", {positions})

        if (positions.length >= 6) {
            await this.showWins(positions);
        }
    }

    getFSMHandlers(): any {
        return {
            ...super.getFSMHandlers(),
            CHECK: {
                ...super.getFSMHandlers()['CHECK'],
                showBonusWin: {
                    on: this.showBonusSymbolsWin.bind(this),
                    check: () => this.store.gameData.mode === "bonus" && (this.store.gameData.prevMode === "main" || this.store.gameData.prevMode === "freespins")
                }
            }
        }
    }
}

// @ts-ignore
Game.src.component.ReelsetComponent = GameReelsetComponent